<template>
    <div class="team_box animate__animated animate__fadeIn">
        <div class="team">
            <div class="search_box">
                <div class="text">班组列表</div>
                <div class="search_btn" @click="fnOpenAddTeam"><span>新增班组</span></div>
                <!-- <div class="search_btn upload" @click="fnUploadTeamCq2"><span>上传重庆市建委</span></div> -->
            </div>
            <div class="cont_list">
                <div class="list_title">
                    <div class="title_item">班组名</div>
                    <div class="title_item">班组负责人</div>
                    <div class="title_item">分包单位</div>
                    <div class="title_item">是否上传</div>
                    <div class="title_item">创建日期</div>
                    <div class="title_item">操作</div>
                </div>
                <div class="list_boxes">
                    <div class="list_box">
                        <div v-if="teamList">
                            <div class="box_line" v-for="(item, index) in teamList" :key="index">
                                <div class="list_item">{{ item.name }}</div>
                                <div class="list_item">{{ item.personnel_name }}</div>
                                <div class="list_item">{{ fnUnitIdGetSubcontract(item.unit_id) }}</div>
                                <div class="list_item" :title="item.is_upload | fnUploadObjToText">
                                    <span>{{ item.is_upload | fnUploadObjToText }}</span>
                                </div>
                                <div class="list_item">{{ item.create_at }}</div>
                                <div class="list_item">
                                    <div>
                                        <button class="item_btn blue"
                                            @click="fnOpenEditTeam(item)"><span>编辑</span></button>
                                        <button class="item_btn red" @click="fnDelete(item)"><span>删除</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 添加编辑班组弹窗 -->
            <div class="dialog_team" v-if="teamWindow">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" :title="teamTitle" center
                    :visible.sync="teamWindow">
                    <div class="reason_body">
                        <div class="body_item">班组名称</div>
                        <div class="body_item"><input type="text" class="input_box" v-model="form.name"
                                placeholder="请输入班组名称" /></div>
                    </div>
                    <div class="reason_body">
                        <div class="body_item">班组负责人</div>
                        <div class="body_item">
                            <el-select v-model="form.personnelId" class="select_box" :popper-append-to-body="false"
                                filterable placeholder="请选择">
                                <el-option label="请选择" value></el-option>
                                <el-option v-for="item in personnelList" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="reason_body">
                        <div class="body_item">分包单位</div>
                        <div class="body_item">
                            <el-select v-model="form.unit_id" class="select_box" :popper-append-to-body="false"
                                filterable placeholder="请选择">
                                <el-option label="请选择" value></el-option>
                                <el-option v-for="item in subcontractList" :key="item.id" :label="item.corpName"
                                    :value="item.id"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="reason_body">
                        <div class="body_item">进场时间</div>
                        <div class="body_item">
                            <el-date-picker value-format="yyyy-MM-dd" v-model="form.entryTime" type="date"
                                placeholder="选择日期"></el-date-picker>
                        </div>
                    </div>

                    <div class="reason_body" style=" height: auto;">
                        <div class="body_item">进场附件</div>
                        <div class="body_item" style="height: auto;">

                            <el-upload action="" list-type="picture-card" class="avatar-uploader-s"
                                :file-list="entryAttachmentsList" :on-preview="handlePictureCardPreview"
                                :on-remove="handleRemoveEntry" :limit="5" :on-exceed="handleExceed" multiple
                                :http-request=" res => { beforePicUpload(res.file, 'entryAttachmentsList');}">
                                <i class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>

                        </div>
                    </div>

                    <div class="reason_body">
                        <div class="body_item">退场时间</div>
                        <div class="body_item">
                            <el-date-picker value-format="yyyy-MM-dd" v-model="form.exitTime" type="date"
                                placeholder="选择日期"></el-date-picker>
                        </div>
                    </div>

                    <div class="reason_body" style=" height: 100px;">
                        <div class="body_item">退场附件</div>
                        <div class="body_item">
                            <el-upload action="" list-type="picture-card" class="avatar-uploader-s"
                                :file-list="exitAttachmentsList" :on-preview="handlePictureCardPreview"
                                :on-remove="handleRemoveExit" :limit="5" :on-exceed="handleExceed" multiple
                                :http-request=" res => { beforePicUpload(res.file, 'exitAttachmentsList');}">
                                <i class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </div>
                    </div>

                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line" style="padding-top: 10px;">
                            <div class="search-btn red" @click="teamWindow = false"><span>取消</span></div>
                            <div class="search-btn" @click="fnAddTeam"><span>保存</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>

            <!-- 删除班组二次确认 -->
            <div class="dialog_team_delete" v-if="deleteWindow">
                <el-dialog custom-class="animate__animated animate__fadeIn team-delete-dialog" :modal="false"
                    title="删除确认" center :visible.sync="deleteWindow" width="360px">
                    <div class="delete_body">
                        <p class="delete_tip">确认删除班组</p>
                        <p class="delete_name">「{{ deleteTeamName }}」</p>
                        <p class="delete_warn">删除后不可恢复</p>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn red" @click="deleteWindow = false"><span>取消</span></div>
                            <div class="search-btn" @click="fnConfirmDelete"><span>删除</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>


            <!-- 上传失败信息弹窗-->
            <div class="dialog_perError" v-if="showErrorInfo">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" top="20vh" :modal="false" title="班组上传失败"
                    :visible.sync="showErrorInfo" center>
                    <div class="cont_list">
                        <div class="list_boxes">
                            <div class="list_box">
                                <div v-if="errorInfoList">
                                    <div class="box_line" v-for="(item, index) in errorInfoList" :key="index">
                                        <div class="list_item">{{ item.msg }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn red" @click="showErrorInfo = false"><span>关闭</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>
            <div class="dialog_perError" v-if="dialogVisible">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" top="20vh" :modal="false" title="图片查看"
                    :visible.sync="dialogVisible" center>
                    <span style="color: #fff;">保存：鼠标右键-将图片另存为</span>
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </div>

            <div class="verify_code" v-if="cq2VerifyCodeShow">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false"
                    :close-on-click-modal="false" title="请输入验证码" :visible.sync="cq2VerifyCodeShow" center>

                    <div style="display: flex;">
                        <img :src="cq2VerifyCodeImg" @click="fnUploadTeamCq2('get')">
                        <input type="text" class="input_box" v-model="cq2VerifyCode" placeholder="请输入验证码" />
                        <div class="search-btn" style="width: 100px;" @click="fnUploadTeamCq2"><span>确定</span>
                        </div>
                    </div>

                </el-dialog>
            </div>

        </div>
    </div>
</template>

<script>
    import request from '@/utils/request';
    import APP from '@/utils/base';
    import {
        Loading
    } from 'element-ui';
    import {
        fnUpload
    } from '@/utils/upload';
    import * as imageConversion from 'image-conversion';
    import {
        fnRequestPlatform
    } from '@/utils/upload';
    export default {
        data() {
            return {
                deleteWindow: false,
                deleteTeamId: '',
                deleteTeamName: '',
                showErrorInfo: false, //上传错误弹窗
                errorInfoList: [], // 错误列表
                teamTitle: '新增班组', // 弹窗名称
                editId: '', // 编辑id
                dialogImageUrl: '',
                dialogVisible: false,
                entryAttachmentsList: [], // 进场附件列表
                exitAttachmentsList: [], // 退场附件列表
                form: {
                    name: '',
                    personnelId: '',
                    unit_id: '', // 分包单位
                    entryTime:'',
                    exitTime:'',
                    extend: {}
                },
                teamWindow: false, // 添加、编辑班组弹窗
                teamList: [], // 班组列表
                personnelList: [], // 项目下人员列表
                subcontractList: [], // 分包单位
                cq2VerifyCodeShow: false,
                cq2VerifyCodeImg: '',
                cq2VerifyCode: '',
            };
        },
        created() {
            this.fnInit();
        },
        methods: {
            // 初始化
            fnInit() {
                this.fnGetSubcontract();
                this.fnGetAllPersonnel();
                this.fnGetTeam();
            },
            fnUploadTeamCq2(_e) {

                if (this.cq2VerifyCodeShow && !this.cq2VerifyCode && _e != 'get') {
                    this.$message.error("请输入验证码！");
                    return;
                }

                fnRequestPlatform({
                        url: '/Cq2/uploadTeamInfo',
                        method: 'POST',
                        data: {
                            carry: {
                                verifyCode: this.cq2VerifyCode
                            }
                        }
                    },
                    res => {
                        if (res.code === 1) {
                            this.cq2VerifyCodeShow = false
                            this.cq2VerifyCode = ''
                            this.$message.success(res.data);
                            this.fnInit();
                            return;
                        }else if (res.code === 3) {
                            this.cq2VerifyCode = ''
                            this.cq2VerifyCodeImg = res.data
                            this.cq2VerifyCodeShow = true
                            return;
                        }
                        this.cq2VerifyCodeShow = false
                        this.cq2VerifyCode = ''

                        if (typeof res.data !== 'string') {
                            this.errorInfoList = res.data;
                            this.showErrorInfo = true;
                        } else {
                            this.$message.error(res.data);
                        }
                        this.fnInit();
                    }
                );
            },
            // 打开新增班组弹窗
            fnOpenAddTeam() {
                this.teamTitle = '新增班组';
                this.editId = '';
                this.form.name = '';
                this.form.personnelId = '';
                this.form.unit_id = ''; // 分包单位
                this.form.extend = {};
                this.form.entryTime = '';
                this.form.exitTime = '';
                this.entryAttachmentsList = []
                this.exitAttachmentsList = []
                this.teamWindow = true;
            },
            // 打开编辑班组弹窗
            fnOpenEditTeam(_data) {
                this.teamTitle = '编辑班组';
                this.editId = _data.id;
                this.form.name = _data.name;
                this.form.personnelId = _data.personnel_id ? Number(_data.personnel_id) : '';
                this.form.unit_id = _data.unit_id; // 分包单位
                this.form.extend = _data.extend ? JSON.parse(_data.extend) : {};
                this.form.entryTime =  this.form.extend.entryTime ? this.form.extend.entryTime :'';
                this.form.exitTime = this.form.extend.exitTime ? this.form.extend.exitTime :'';
                this.entryAttachmentsList = this.form.extend.entryAttachments ? this.form.extend.entryAttachments : []
                this.exitAttachmentsList = this.form.extend.exitAttachments ? this.form.extend.exitAttachments : []
                this.teamWindow = true;
            },
            // 获取所有班组
            fnGetTeam(_obj, _cb) {
                request({
                        url: 'team/getTeam',
                        method: 'GET',
                        params: _obj
                    })
                    .then(res => {
                        _cb && _cb(res);
                        this.teamList = res.data;
                        if (this.teamList.length == 0) {
                            this.$message.warning('暂无数据');
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 班组搜索
            fnSearch() {
                this.fnGetTeam({
                        name: this.searchName,
                        personnel_name: this.searchPersonnel_name,
                        create_at: this.searchCreateDate
                    },
                    res => {
                        this.teamList = res.data;
                        if (this.teamList.length == 0) {
                            this.$message.warning('暂无数据');
                        }
                    }
                );
            },
            // 获取项目下所有人员
            fnGetAllPersonnel() {
                request({
                        url: 'personnel/getAllPersonnel',
                        method: 'GET'
                    })
                    .then(res => {
                        this.personnelList = res.data;
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 获取所有分包单位
            fnGetSubcontract() {
                request({
                        url: 'project/getAllRegionExtend',
                        method: 'GET',
                        params: {
                            region: 'cq2_corp'
                        }
                    })
                    .then(res => {
                        this.subcontractList = res.data;
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },

            // 添加、编辑班组
            fnAddTeam() {
                if (!this.form.name) {
                    this.$message.warning('班组名不能为空');
                    return;
                }
                if (!this.form.unit_id) {
                    this.$message.warning('分包单位不能为空');
                    return;
                }

                let _url = 'team/addTeam';

                this.form.extend.entryTime = this.form.entryTime
                this.form.extend.exitTime = this.form.exitTime
                this.form.extend.entryAttachments = this.entryAttachmentsList
                this.form.extend.exitAttachments = this.exitAttachmentsList

                let _data = {
                    name: this.form.name,
                    unit_id: this.form.unit_id,
                    extend: JSON.stringify(this.form.extend)
                };
                if (this.form.personnelId) {
                    _data.personnel_id = this.form.personnelId;
                    this.personnelList.forEach(_item => {
                        if (_item.id == _data.personnel_id) {
                            _data.personnel_name = _item.name;
                        }
                    });
                }
                if (this.editId) {
                    _url = 'team/editTeam';
                    _data.id = this.editId;
                }

                request({
                        url: _url,
                        method: 'POST',
                        data: _data
                    })
                    .then(res => {
                        this.$message.success(res.data);
                        this.teamWindow = false;
                        this.fnGetTeam();
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 删除班组
            fnDelete(_data) {
                this.deleteTeamId = _data.id;
                this.deleteTeamName = _data.name || '';
                this.deleteWindow = true;
            },
            // 确认删除班组
            fnConfirmDelete() {
                if (!this.deleteTeamId) {
                    this.deleteWindow = false;
                    return;
                }
                request({
                    url: 'team/deleteTeam',
                    method: 'POST',
                    data: {
                        id: this.deleteTeamId
                    }
                })
                    .then(res => {
                        this.$message.success(res.data);
                        this.deleteWindow = false;
                        this.deleteTeamId = '';
                        this.deleteTeamName = '';
                        this.fnGetTeam();
                    })
                    .catch(err => {
                        this.$message.error((err && err.data) || '删除失败');
                    });
            },

            // 按id获取分包单位
            fnUnitIdGetSubcontract(_unitId) {
                for (let key in this.subcontractList) {
                    if (this.subcontractList[key].id == _unitId) {
                        return this.subcontractList[key].corpName;
                    }
                }
                return '';
            },
            // 上传图片
            beforePicUpload(_file, _type) {

                let _that = this;

                let _loadingInstance = Loading.service({
                    fullscreen: true,
                    background: 'rgba(255,255,255,0.7)',
                    spinner: 'el-icon-loading',
                    text: '图片上传中'
                });

                // 把图片文件压缩到1000kb
                imageConversion.compressAccurately(_file, 1000).then(_res => {
                    let reader = new FileReader();
                    reader.onload = function() {
                        // base64转文件流对象
                        let _fileObject = APP.fnBase64ToFile(this.result);
                        let formData = new FormData();
                        formData.append('file', _fileObject);
                        formData.append('type', 'image');
                        // if (_base64.indexOf('data:image/') != -1) {
                        //     _base64 = _base64.split(',')[1];
                        // }
                        fnUpload(formData, res => {

                            _that[_type].push({
                                name: _file.name,
                                url: res.data.file_url,
                            })

                            _loadingInstance.close();
                        });
                    };
                    reader.readAsDataURL(_res);
                });
                return false; // 阻止组件自动上传图片
            },
            // 删除合同图片
            handleRemoveEntry(file, fileList) {
                let arr = []
                this.entryAttachmentsList.forEach(e => {
                    if (e.uid != file.uid) arr.push(e);
                })
                this.entryAttachmentsList = arr
            },
            handleRemoveExit(file, fileList) {
                let arr = []
                this.exitAttachmentsList.forEach(e => {
                    if (e.uid != file.uid) arr.push(e);
                })
                this.exitAttachmentsList = arr
            },
            // 查看合同图片
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleExceed(files, fileList) {
                this.$message.warning('附件总数不超过 5 个');
            },
        }
    };
</script>

<style lang="scss" scoped>
    @import '~@/styles/mixin.scss';

    .team_box {
        width: 1920px;
        height: 858px;
        position: relative;
        overflow: hidden;

        .team {
            position: absolute;
            left: 0;
            right: -20px;
            top: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
        }
    }

    .search_box {
        width: 1880px;
        height: 50px;
        margin-top: 24px;
        margin-left: 20px;
        text-align: center;
        font-size: 34px;

        .search_btn {
            width: 106px;
            height: 36px;
            background: url(../../../assets/img/btn_bg_mid.png) no-repeat;
            background-size: 100% 100%;
            position: absolute;
            left: 40px;
            top: 35px;
            color: #ffffff;
            font-size: 14px;
            cursor: pointer;
            @include flex-box(center, center);

            &.upload {
                width: 130px;
                left: 160px;
            }

            span {
                margin-top: -5px;
            }
        }
    }

    .cont_list {
        margin-top: 29px;
        margin-left: 28px;
        width: 1864px;
        height: 755px;
        border-radius: 10px;
        background-color: rgba(29, 68, 149, 0.1);

        .list_title {
            width: 1864px;
            height: 48px;
            background: url(../../../assets/img/per_list_bg.png) no-repeat;
            background-size: 100% 100%;
            @include flex-box(flex-start, center);

            .title_item {
                height: 48px;
                @include flex-box(center, center);

                &:nth-child(1) {
                    width: 286px;
                    margin: 0 4px 0 40px;
                }

                &:nth-child(2) {
                    width: 296px;
                    margin-right: 4px;
                }

                &:nth-child(3) {
                    width: 356px;
                    margin-right: 4px;
                }

                &:nth-child(4) {
                    width: 296px;
                    margin-right: 4px;
                }

                &:nth-child(5) {
                    width: 296px;
                    margin-right: 4px;
                }

                &:nth-child(6) {
                    width: 234px;
                    margin-right: 40px;
                }
            }
        }

        .list_boxes {
            width: 1864px;
            height: 707px;
            position: relative;
            overflow: hidden;

            .list_box {
                position: absolute;
                left: 0;
                right: -25px;
                top: 0;
                bottom: 0;
                overflow-x: hidden;
                overflow-y: auto;

                .box_line {
                    width: 1784px;
                    height: 70px;
                    margin: 7px 0 0 40px;
                    font-size: 16px;
                    color: #ffffff;
                    border-bottom: 1px dashed #1d4495;
                    @include flex-box(flex-start, center);

                    .list_item {
                        height: 70px;
                        text-align: center;
                        @include flex-box(center, center);

                        &:nth-child(1) {
                            width: 286px;
                            margin-right: 4px;
                        }

                        &:nth-child(2) {
                            width: 296px;
                            margin-right: 4px;
                        }

                        &:nth-child(3) {
                            width: 356px;
                            margin-right: 4px;
                        }

                        &:nth-child(4) {
                            width: 296px;
                            margin-right: 4px;
                        }

                        &:nth-child(5) {
                            width: 296px;
                            margin-right: 4px;
                        }

                        &:nth-child(6) {
                            width: 234px;
                        }

                        div {
                            @include flex-box(center, center);

                            .item_btn {
                                width: 69px;
                                height: 32px;
                                line-height: 32px;
                                margin: 0 2px;
                                font-size: 14px;
                                color: #ffffff;
                                border: none;
                                cursor: pointer;
                                @include flex-box(center, center);

                                &.blue {
                                    background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
                                    background-size: 100% 100%;
                                }

                                &.red {
                                    background: url(../../../assets/img/btn_bg_rsm.png) no-repeat;
                                    background-size: 100% 100%;
                                }

                                span {
                                    margin-top: -2px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .dialog_team {
        >>>.el-dialog {
            width: 530px;
            height: 600px;
            margin-top: 30vh !important;
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid rgba(58, 116, 221, 1);
            overflow-x: hidden;
            overflow-y: auto;
        }

        >>>.el-form-item__label {
            color: #4db4f4;
        }

        >>>.el-dialog__title {
            color: #4db4f4;
        }

        >>>.el-dialog__close {
            color: #4db4f4;
        }



        .reason_body {
            width: 440px;
            height: 40px;
            line-height: 40px;
            color: #4db4f4;
            margin: 0 auto;
            @include flex-box();

            .body_item {
                height: 40px;
                color: #ffffff;

                &:first-child {
                    width: 120px;
                    text-align: center;
                }

                &:nth-child(2) {
                    width: 360px;
                }

                .input_box {
                    background-color: rgba(49, 88, 128, 0.6);
                    width: 320px;
                    height: 30px;
                    line-height: 40px;
                    padding-left: 15px;
                    color: #4db4f4;
                    font-size: 12px;
                    border-radius: 2px;
                    outline: none;
                    border: none;

                    &::-webkit-input-placeholder {
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &::-moz-placeholder {
                        /* Mozilla Firefox 19+ */
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &:-moz-placeholder {
                        /* Mozilla Firefox 4 to 18 */
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &:-ms-input-placeholder {
                        /* Internet Explorer 10-11 */
                        color: rgba(77, 180, 244, 0.7);
                    }
                }

                .select_box {
                    width: 320px;
                    height: 30px;
                    line-height: 30px;
                    border-radius: 2px;
                    background-color: rgba(49, 88, 128, 0.6);
                }
            }

            >>>.el-date-editor {
                width: 320px;

                .el-input__inner {
                    background-color: rgba(49, 88, 128, 0.6);
                    width: 320px;
                }
            }

            >>>.avatar-uploader-s {
                li {
                    width: 100px;
                    height: 100px;
                }
            }

            >>>.el-input__inner {

                width: 211px;
                height: 30px;
                border-radius: 2px;
                border: none;
                color: rgba(77, 180, 244, 0.7);
                background: transparent;

                &::-webkit-input-placeholder {
                    color: rgba(77, 180, 244, 0.7);
                }

                &::-moz-placeholder {
                    /* Mozilla Firefox 19+ */
                    color: rgba(77, 180, 244, 0.7);
                }

                &:-moz-placeholder {
                    /* Mozilla Firefox 4 to 18 */
                    color: rgba(77, 180, 244, 0.7);
                }

                &:-ms-input-placeholder {
                    /* Internet Explorer 10-11 */
                    color: rgba(77, 180, 244, 0.7);
                }
            }

            >>>.el-select__caret {
                color: rgba(77, 180, 244, 0.7);
            }

            >>>.el-select-dropdown {
                background-color: rgba(9, 17, 32, 1);
                border: 1px solid rgba(77, 180, 244, 1);
            }

            >>>.popper__arrow {
                border-bottom-color: rgba(77, 180, 244, 1) !important;
            }

            >>>.el-select-dropdown__item {
                color: rgba(77, 180, 244, 0.7);
            }

            >>>.el-select-dropdown__item:hover {
                color: #409eff;
            }

            >>>.el-select-dropdown__item.hover {
                color: #409eff;
            }

            >>>.el-input__icon {
                color: rgba(77, 180, 244, 0.7);
            }

            >>>.avatar-uploader {
                line-height: 100px;
                margin-right: 10px;

                img {
                    width: 98px;
                    height: 98px;
                    border-radius: 2px;
                }
            }

            >>>.el-upload {
                width: 100px;
                height: 100px;
                line-height: 100px;
            }
        }

        .btn_line {
            @include flex-box(center, center);
        }
    }

    .verify_code {
        >>>.el-dialog {
            width: 500px;
            height: 130px;
            margin-top: 30vh !important;
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid rgba(58, 116, 221, 1);
        }

        >>>.el-form-item__label {
            color: #4db4f4;
        }

        >>>.el-dialog__title {
            color: #4db4f4;
        }

        >>>.el-dialog__close {
            color: #4db4f4;
        }

        >>>.el-dialog__body {
            padding: 10px 20px;
        }

        .input_box {
            background-color: rgba(49, 88, 128, 0.6);
            width: 280px;
            height: 30px;
            line-height: 40px;
            padding-left: 15px;
            color: #4db4f4;
            font-size: 12px;
            border-radius: 2px;
            outline: none;
            border: none;

            &::-webkit-input-placeholder {
                color: rgba(77, 180, 244, 0.7);
            }

            &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-ms-input-placeholder {
                /* Internet Explorer 10-11 */
                color: rgba(77, 180, 244, 0.7);
            }
        }

    }

    // 弹窗公共样式
    .dialog_perError {
        .btn_line {
            @include flex-box(center, center);
        }

        >>>.el-dialog {
            width: 910px;
            height: 600px;
            // margin-top: 20vh!important;
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid rgba(58, 116, 221, 1);
        }

        >>>.el-form-item__label {
            color: #4db4f4;
        }

        >>>.el-dialog__title {
            color: #4db4f4;
        }

        >>>.el-dialog__close {
            color: #4db4f4;
        }
    }

    .dialog_perError {
        >>>.el-dialog {
            width: 900px;
            height: 600px;
            // margin-top: 20vh!important;
        }

        .cont_list {
            width: 840px;
            height: 425px;
            color: #ffffff;
            font-size: 16px;
            border-radius: 10px;
            margin: 0;
            background-color: rgba(29, 68, 149, 0.1);

            .list_title {
                width: 840px;
                height: 48px;
                background: url(../../../assets/img/per_list_bg.png) no-repeat;
                background-size: 100% 100%;
                @include flex-box(flex-start, center);

                .title_item {
                    height: 48px;
                    @include flex-box(center, center);

                    &:nth-child(1) {
                        width: 156px;
                        margin: 0 4px 0 30px;
                    }

                    &:nth-child(2) {
                        width: 156px;
                        margin-right: 4px;
                    }

                    &:nth-child(3) {
                        width: 460px;
                        margin-right: 30px;
                    }
                }
            }

            .list_boxes {
                width: 780px;
                height: 377px;
                margin-left: 30px;
                position: relative;
                overflow: hidden;

                .list_box {
                    position: absolute;
                    left: 0;
                    right: -25px;
                    top: 0;
                    bottom: 0;
                    overflow-x: hidden;
                    overflow-y: auto;

                    .box_line {
                        width: 780px;
                        height: 70px;
                        margin: 5px 0 0 0px;
                        border-bottom: 1px dashed #1d4495;
                        @include flex-box(flex-start, center);

                        &:hover {
                            background-color: rgba(49, 88, 128, 0.4);
                        }

                        .list_item {
                            color: #f56c6c;
                            height: 70px;
                            text-align: center;
                            @include flex-box(center, center);

                            &:nth-child(1) {
                                width: 780px;
                            }

                            img {
                                width: 60px;
                                height: 60px;
                                border-radius: 50%;
                            }

                            span {
                                width: 100%;
                                cursor: pointer;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                        }
                    }
                }
            }
        }
    }

    .dialog_team_delete {
        >>> .el-dialog.team-delete-dialog {
            width: 360px !important;
            height: auto !important;
            margin-top: 32vh !important;
            background-color: rgba(9, 17, 32, 0.98);
            border: 1px solid rgba(58, 116, 221, 1);
            border-radius: 4px;
        }

        >>> .el-dialog__header {
            padding: 14px 16px 8px;
        }

        >>> .el-dialog__title {
            color: #4db4f4;
            font-size: 16px;
            line-height: 22px;
        }

        >>> .el-dialog__headerbtn {
            top: 14px;
            right: 14px;
        }

        >>> .el-dialog__close {
            color: #4db4f4;
        }

        >>> .el-dialog__body {
            padding: 4px 20px 8px;
        }

        >>> .el-dialog__footer {
            padding: 8px 16px 16px;
        }

        .delete_body {
            text-align: center;
            padding: 6px 0 4px;
        }

        .delete_tip {
            margin: 0;
            color: rgba(255, 255, 255, 0.85);
            font-size: 14px;
            line-height: 22px;
        }

        .delete_name {
            margin: 8px 0;
            color: #4db4f4;
            font-size: 15px;
            line-height: 24px;
            word-break: break-all;
        }

        .delete_warn {
            margin: 0;
            color: rgba(245, 108, 108, 0.9);
            font-size: 12px;
            line-height: 18px;
        }

        .btn_line {
            @include flex-box(center, center);
        }
    }

</style>




// WEBPACK FOOTER //
// src/views/Team/teamCq2/index.vue